import React, { useState, useEffect } from 'react'
import {
  array,
  object,
  bool,
} from 'prop-types'
import axios from 'axios'

import ItemsListing from './ItemsListing'
import { TrackingProvider } from './Tracking.context'

function ItemsListingWrapper({
  data,
  cart = {
    value: 0,
    applicableCldValue: 15,
    isSaleOff: false,
    isCLDDisabled: true,
    itemIds: [],
  },
  withCtrTracking = false,
  isAutoAdjusting = false,
  isWithCarousel = false,
  ...rest
}) {
  const currentItemsIds = data.map((item) => item.id)
  const [isLoading, setIsLoading] = useState(false)
  const [trackingData, setTrackingData] = useState([])
  const shouldFetchTrackingInfo = currentItemsIds.length > 0 && !trackingData.length

  const fetchTrackingInfo = async () => {
    const trackingLink = '/listing_page/tracking_info'
    const keywordsLink = `item_ids=${currentItemsIds}`
    const trackingInfoLink = `${trackingLink}?${keywordsLink}`

    axios
      .get(trackingInfoLink)
      .then((response) => {
        handleResponse(response)
      })
      .catch((error) => {
        if (window.sendErrorToSentry) {
          window.sendErrorToSentry(error, { tags: { section: 'Legacy listing tracking info' } })
        }
      })
  }

  const handleResponse = (response) => {
    const { data: responseData } = response

    if (data) {
      const { ga_attributes } = responseData
      setTrackingData(ga_attributes)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    if (!isLoading && shouldFetchTrackingInfo) {
      setIsLoading(true)
      fetchTrackingInfo()
    }
  }, [])

  return (
    <TrackingProvider
      perPage={data.length}
      withCtrTracking={withCtrTracking}
      trackingData={trackingData}
    >
      <ItemsListing
        isTrackingEnabled={trackingData.length > 0}
        data={data}
        cart={cart}
        withCtrTracking={withCtrTracking}
        isAutoAdjusting={isAutoAdjusting}
        isWithCarousel={isWithCarousel}
        {...rest}
      />
    </TrackingProvider>
  )
}

ItemsListingWrapper.propTypes = {
  data: array.isRequired,
  cart: object,
  withCtrTracking: bool,
  isAutoAdjusting: bool,
  isWithCarousel: bool,
}

export default ItemsListingWrapper
